var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/medal-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.0834 80.4737L84.9334 82.1637C83.3301 82.5537 82.0734 83.767 81.7267 85.3704L80.2101 91.7404C79.3867 95.207 74.9667 96.2904 72.6701 93.5604L59.7134 78.6537C58.6734 77.4404 59.2367 75.5337 60.7967 75.1437C68.4667 73.2804 75.3567 68.9904 80.4267 62.8804C81.2501 61.8837 82.7234 61.7537 83.6334 62.6637L93.2534 72.2837C96.5467 75.577 95.3767 79.6937 92.0834 80.4737Z",
    fill: "#7DEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6997 80.4737L18.8497 82.1637C20.4531 82.5537 21.7097 83.767 22.0564 85.3704L23.5731 91.7404C24.3964 95.207 28.8164 96.2904 31.1131 93.5604L44.0697 78.6537C45.1097 77.4404 44.5464 75.5337 42.9864 75.1437C35.3164 73.2804 28.4264 68.9904 23.3564 62.8804C22.5331 61.8837 21.0597 61.7537 20.1497 62.6637L10.5297 72.2837C7.2364 75.577 8.4064 79.6937 11.6997 80.4737Z",
    fill: "#7DEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.0003 9.10364C35.2303 9.10364 21.667 22.667 21.667 39.437C21.667 45.7203 23.5303 51.4836 26.737 56.2936C31.417 63.227 38.827 68.1236 47.4503 69.3803C48.9237 69.6403 50.4403 69.7703 52.0003 69.7703C53.5603 69.7703 55.077 69.6403 56.5503 69.3803C65.1737 68.1236 72.5837 63.227 77.2637 56.2936C80.4703 51.4836 82.3337 45.7203 82.3337 39.437C82.3337 22.667 68.7703 9.10364 52.0003 9.10364ZM65.2603 38.4836L61.6637 42.0803C61.057 42.687 60.7103 43.857 60.927 44.7236L61.967 49.187C62.7903 52.697 60.927 54.0836 57.807 52.2203L53.4737 49.6636C52.6937 49.187 51.3937 49.187 50.6137 49.6636L46.2803 52.2203C43.1603 54.0403 41.297 52.697 42.1203 49.187L43.1603 44.7236C43.3337 43.9003 43.0303 42.687 42.4237 42.0803L38.7403 38.4836C36.617 36.3603 37.3103 34.237 40.257 33.7603L44.8937 32.9803C45.6737 32.8503 46.5837 32.157 46.9303 31.4636L49.487 26.3503C50.8737 23.577 53.127 23.577 54.5137 26.3503L57.0703 31.4636C57.417 32.157 58.327 32.8503 59.1503 32.9803L63.787 33.7603C66.6903 34.237 67.3837 36.3603 65.2603 38.4836Z",
    fill: "#27C6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalStar);
export default __webpack_public_path__ + "static/media/medal_star.05b191f2e381b0e9d289900ff53b2cd3.svg";
export { ForwardRef as ReactComponent };